// extracted by mini-css-extract-plugin
export default {"container":"CustomCheckbox_container__ykD2S","checkmark":"CustomCheckbox_checkmark__ASd-+"};